export default __webpack_public_path__ + "static/media/milk3.bb883c34.jpg";